import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const TipoComprobanteService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Comprobante_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_cat_tipo_comprobante: null,
			tipo_comprobante: form.tipo_comprobante,
			descripcion: form.descripcion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Comprobante_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_tipo_comprobante: form.id_cat_tipo_comprobante,
			tipo_comprobante: form.tipo_comprobante,
			descripcion: form.descripcion,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Comprobante_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_tipo_comprobante) => {
		let params = {
			id_cat_tipo_comprobante: id_cat_tipo_comprobante
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Comprobante_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
